import { identifiers, tabLabels, buttonIds } from 'components/FreecodePage/FreecodeLayout/FreecodeLayoutConstants';

const TOUR_DATA = [
  {
    title: 'Description',
    text: 'Click here to view the description.',
    elementId: tabLabels[identifiers.description].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Summary',
    text: 'Click here to view the summary displayed on the landing page.',
    elementId: tabLabels[identifiers.summary].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'API Methods',
    text: 'Click here to view the available API methods.',
    elementId: tabLabels[identifiers.api].tabId,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Selected Language',
    text: 'Candidate selected language is displayed here.',
    elementId: buttonIds.liveCodingSelectedLanguage,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'right',
  },
  {
    title: 'Select Language',
    text: 'Click here to select your preferred programming language.',
    elementId: buttonIds.selectLanguage,
    heightMultiplier: 1,
    widthMultiplier: 0.5,
    arrow: 'top',
  },
  {
    title: 'Run Code',
    text: 'Click here to run your code and see how it performs on test levels.',
    elementId: buttonIds.runButton,
    arrow: 'right',
    heightMultiplier: 0.5,
  },
  {
    title: 'Status',
    text: 'The candidates code status is shown here(Idle, Typing or Running Code).',
    elementId: buttonIds.liveCodingStatusButton,
    arrow: 'right',
    heightMultiplier: 0.5,
  },
  {
    title: 'Console',
    text: 'When running the code, the console output will appear here.',
    elementId: tabLabels[identifiers.console].tabId,
    heightMultiplier: 0,
    widthMultiplier: 0.5,
    arrow: 'bottom',
  },
  {
    title: 'Score',
    text: 'When running the code, the score per level can be seen here.',
    elementId: tabLabels[identifiers.score].tabId,
    heightMultiplier: 0,
    widthMultiplier: 0.5,
    arrow: 'bottom',
  },
  {
    title: 'Canvas',
    text: "After running the code, a replay of the program's behaviour will be shown here.",
    elementId: 'freecodePlayer',
    widthMultiplier: 1,
    heightMultiplier: 0.5,
    arrow: 'left',
    wideScreen: {
      widthMultiplier: 0,
      arrow: 'right',
    },
  },
  {
    title: 'Submit Code',
    text: 'Click here to submit your solution.',
    elementId: buttonIds.submitButton,
    arrow: 'right',
  },
  {
    title: 'Layout',
    text: 'Manually manage the editor layout.',
    elementId: buttonIds.layoutDropdown,
    arrow: 'right',
  },
  {
    title: 'Publish and Archive',
    text: 'Use this dropdown to handle the published status of the implementation.',
    elementId: buttonIds.publishDropdown,
    arrow: 'right',
  },
  {
    title: 'Report issues',
    text: 'Here you can report any issues you encounter.',
    elementId: buttonIds.reportButton,
    arrow: 'right',
  },
  {
    title: 'Save Your work',
    text: 'Press on this button to manually save your changes.',
    elementId: buttonIds.saveButton,
    arrow: 'right',
  },
  {
    title: 'Export zip',
    text: 'Press on this to export the implementation as a zip file.',
    elementId: buttonIds.exportButton,
    arrow: 'right',
  },
  {
    title: 'Import zip',
    text: 'Press on this to import a zip file that will overwrite the implementation.',
    elementId: buttonIds.importButton,
    arrow: 'right',
  },
  {
    title: 'FS Wiki',
    text: 'This link will take you to the Future Skill help wiki.',
    elementId: buttonIds.wikiLink,
    arrow: 'right',
  },
  {
    title: 'Toggle Light mode',
    text: 'Here you can toggle between light and dark mode.',
    elementId: buttonIds.toggleDarkMode,
    arrow: 'right',
  },
  {
    title: 'Help Overlay',
    text: 'You can restart this tour overlay from here.',
    elementId: buttonIds.helpButton,
    arrow: 'right',
  },
];

export default TOUR_DATA;
